import React from 'react';

import createStyle from 'shared-utils/src/createStyle';

import Grid from '../Grid';
import GridItem from '../GridItem';

import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

export default function PageGrid({ sidebar, contClassName, children }) {
  const cls = useStyles();

  return (
    <Grid className={cls[mainCls]}>
      <GridItem className={`${cls[`${mainCls}__main`]} ${contClassName}`}>
        {children}
      </GridItem>      
      <GridItem
        behavior="fixed"
        className={cls[`${mainCls}__col`]}
      >
        {sidebar}
      </GridItem>
    </Grid>
  );
}